/**
 * Get the browser's current computed timezone
 */
export function currentTimezone(): string | undefined {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
